import Auth from "./auth";
import Drawer from "./drawer";
import React from "react";
import { useAuth } from "../context/global";

const Routes = () => {
    const { isAuth } = useAuth();
    return isAuth ? <Drawer /> : <Auth />;
};

export default Routes;
